import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import blogData from "../../../data/blogs/Blog.json";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Latestupdates2 = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const lastSixBlogs = [...blogData].slice(-10).reverse();
    setBlogs(lastSixBlogs);
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="py-10 bg-[#E5E7EB]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 500,
              fontSize: "28px",
              lineHeight: "50px",
              color: "rgb(55, 65, 81)",
            }}
            className="mb-2"
          >
            Latest Updates
          </h2>
        </div>

        <div style={{ fontFamily: "InstrumentSans" }}>
          <Slider {...settings}>
            {blogs.map((blog) => (
              <div key={blog.id} className="px-3">
                <Link
                  to={`/blogs/${blog.slug}`}
                  className="font-medium text-black flex items-center no-underline hover:no-underline"
                >
                  {" "}
                  <div className="bg-white rounded-xl shadow-md overflow-hidden h-full flex flex-col transition-transform duration-300 hover:shadow-xl hover:-translate-y-1">
                    <div className="relative">
                      <img
                        src={blog.thumbImg}
                        alt={blog.h1Heading || blog.h2Heading || "Blog Image"}
                        className="w-full h-56 object-cover"
                      />
                      <div className="absolute rounded-sm top-0 right-0 bg-[#353D4B] text-white px-3 py-1 text-sm">
                        {blog.date}
                      </div>
                    </div>
                    <div className="p-4 flex flex-col flex-grow">
                      <div className="text-sm text-gray-500 mb-2">
                        <span className="mr-3">
                          <i className="fas fa-user mr-1"></i> {blog.author}
                        </span>
                      </div>
                      <h3 className="text-lg font-semibold mb-2 text-gray-800 line-clamp-2">
                        {blog.h1Heading || blog.h2Heading || ""}
                      </h3>

                      <p className="text-gray-600 mb-3 line-clamp-2">
                        {(
                          blog.h1Content?.text ||
                          blog.h2Content?.text ||
                          ""
                        ).substring(0, 90)}
                        ...
                      </p>

                      <div className="mt-auto">Read More...</div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Latestupdates2;
